export default {
  methods: {
    // expected input: [{name: 'material name', percentage: 50}, ...], expected output: '50% material name, ...'
    formattedMaterialsList (materials) {
      return materials.map(m => `${m.percentage ? m.percentage + '% ' : ''}${m.name}`).join(', ') ?? ''
    }
  }
}
